import fetchKeyHouseApi from './KeyHouseFetcher.js';

//POST
export const createSupport = async (mail, description) => {
    return await fetchKeyHouseApi('support', undefined, [["description", description], ["mail", mail]], 'POST');
};
